/* eslint-disable react/jsx-indent */
import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import router from 'umi/router';
import { Button, Form, Tooltip, message, Badge, Modal, Icon, Popconfirm, Dropdown, Menu } from 'antd';
import SelectUser from 'nbugs-select-user-v4.0';
import SelectUserRange from 'nbugs-select-user-range-v4.0';
import SelectUserResult from 'nbugs-select-user-result-v4.0';
import Container from '../../../../../components/Container';
import FormCreate from "../../../../../components/FormCreate/index";
import ListPage from '../../../../../components/ListPage';
import SelectList from '../../ArticlePublished/components/SelectList';
import { getAppCode, eduAppCode } from '../../utils/utils';
import { getLabelStrData } from '../../utils/convertData';
import styles from './index.less';
import { getPathHeader } from '../../../../../utils/utils';

const { ListTable } = ListPage;
const { confirm } = Modal;
const { DateAndTime, FormSelect } = FormCreate;

const naozhongIcon = 'https://s.xiaoyuanhao.com/file/0667e1a2-9dc4-4e0e-91be-4847d7b23ddd.png';

const formAppData = {
  17: '微官网',
  18: '活动打卡'
}

@connect()
class EditCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      loading: false,
      totalElements: 0,
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
      },
      orgType: '',
      selectedRowKeys: [],
      selectedRows: [],
      showSelectModalVisible: false,
      selectId: '',
      isTimeModalVisible: false,
      selectSignature: '',
      selectUserRangeModalVisible: false,
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.fetchOrgType(params);
  }

  fetchOrgType = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'editCheck/fetchOrgType',
    })
      .then(res => {
        this.setState(
          {
            loading: false,
            orgType: res,
          },
          () => {
            this.setColumns();
            this.fetchEditAndCheckList(params);
          }
        );
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchEditAndCheckList = params => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'editCheck/fetchEditAndCheckList',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchNewsPublish = ids => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'editCheck/fetchNewsPublish',
      params: {
        ids: ids.join(','),
        appCode: getAppCode(),
      },
    })
      .then(() => {
        const { params } = this.state;
        this.setState({
          loading: false,
          selectedRowKeys: [],
          selectedRows: [],
        });
        message.success('发布成功');
        this.fetchEditAndCheckList({ ...params, page: 1, pageSize: 10 });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchNewsPreview = ids => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'editCheck/fetchNewsPreview',
      params: {
        id: ids.join(','),
        appCode: getAppCode(),
      },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('预览发布成功');
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  userChooseRemove = ids => {
    const { dispatch } = this.props;
    const { params } = this.state;
    const that = this;
    confirm({
      title: '确定移除选中的文章',
      content: '移除后，文章变更为拟稿状态并回到创建人新建列表',
      onOk() {
        dispatch({
          type: 'editCheck/fetchNewsRemove',
          params: {
            ids: ids.join(','),
          },
        }).then(
          res => {
            message.success('移除成功');
            that.setState({
              selectedRows: [],
            });
            that.fetchOrgType(params);
          },
          error => {
            console.log(error);
          }
        );
      },
    });
  };

  sureSend = (selectId, id, selectIdType) => {
    const that = this;
    const fetchParams = {
      appCode: getAppCode(),
      selectId,
      selectIdType,
      ids: id
    };
    confirm({
      title: '确认批量设置所有资讯的对象范围?',
      content: '（已设置发布对象的资讯不更新对象范围）',
      okText: '确认',
      cancelText: '取消',
      onOk() {
        that.fetchUpdateSelectId(fetchParams);
        that.setState({
          selectedRows: [],
        })
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  setSelectOrg = (id, selectIdType) => {
    const that = this;
    if (selectIdType === 5) {
      that.sureSend('', id, selectIdType)
    }
    if (selectIdType === 1) {
      SelectUser.show({
        multiple: true,
        selectType: 'dept',
        strictOrgRel: false,
        showTabList: ['orgRel'],
        dialogProps: {
          title: '选择对象',
        },
        searchPlaceholder: '搜索名称',
        selectSignature: '',
        isSaveSelectSignature: true,
        requestParams: {
          strictUser: true,
          selectTypeList: ['org_rel'],
        },
        onOk: data => {
          that.sureSend(data.selectSignature, id, selectIdType)
        },
      });
    }
    if (selectIdType === 2) {
      this.setState({ selectUserRangeModalVisible: true })
    }
  };

  fetchUpdateSelectId = fetchParams => {
    const { dispatch } = this.props;
    const { params } = this.state;
    dispatch({
      type: 'editCheck/fetchUpdateSelectId',
      params: fetchParams,
    })
      .then(() => {
        this.setState({ loading: false, selectedRowKeys: [] });
        this.fetchOrgType(params);
        message.success('设置成功');
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showSelectOrg = selectId => {
    this.setState({
      showSelectModalVisible: true,
      selectId,
    });
  };

  showPublisher = (selectId, selectIdType) => {
    if (selectId) {
      return (
        <div
          style={{ color: '#1785EC' }}
          onClick={e => {
            e.stopPropagation();
            this.showSelectOrg(selectId);
          }}
        >
          查看
        </div>
      )
    }
    if (selectIdType === 5) {
      return <div onClick={e => { e.stopPropagation() }}>本组织</div>
    }
    return '-'
  }

  confirmCancleTimeSend = id => {
    const { dispatch } = this.props;
    const { params } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'editCheck/fetchCancelTimedPublish',
      params: {
        ids: id,
        appCode: getAppCode(),
      },
    })
      .then(() => {
        this.setState({
          selectedRows: [],
        });
        this.fetchOrgType(params);
        message.success('操作成功');
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  }

  renderTimeTooltip = (time, formApp) => {
    const { orgType } = this.state;
    return (
      <Tooltip
        placement="top"
        title={
          <>
            <div>
              发布时间 : {moment(time).format('YYYY-MM-DD HH:mm')}
            </div>
            {
              orgType === 'education_bureau' && (
                <div>
                  发布应用 : {formAppData[formApp]}
                </div>
              )
            }
          </>
        }
      >
        <img src={naozhongIcon} alt='' />
      </Tooltip>
    )
  }

  setColumns = () => {
    const { orgType } = this.state;
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 200,
        fixed: 'left',
        render: (text, record) => {
          const { isTiming, timingPushTime, fromApp } = record.newsInfoExtend;
          if (text.length <= 20) {
            return (
              <span className='title-wrap'>
                {
                  isTiming === 1 && this.renderTimeTooltip(timingPushTime, fromApp)
                }
                <span>{text}</span>
              </span>
            )
          }
          return (
            <span className='title-wrap'>
              {
                isTiming === 1 && this.renderTimeTooltip(timingPushTime, fromApp)
              }
              <Tooltip placement="top" title={text}>
                <span>{text.substring(0, 20)}...</span>
              </Tooltip>
            </span>

          );
        },
      },
      {
        title: '来源',
        dataIndex: 'creatorOrgName',
        key: 'creatorOrgName',
        width: 180,
      },
      {
        title: '发布者',
        dataIndex: 'publishUserName',
        key: 'publishUserName',
        width: 160,
        render: text => {
          if (text) {
            if (text.length <= 8) {
              return <span>{text}</span>;
            }
            return (
              <Tooltip placement="top" title={text}>
                <span>{text.substring(0, 8)}...</span>
              </Tooltip>
            );
          }
          return <span>-</span>;
        },
      },
      {
        title: '审批时间',
        dataIndex: 'time',
        key: 'time',
        width: 180,
        render: (text, record) => {
          const { newsInfoExtend = {} } = record;
          const { workFlowFinishTime } = newsInfoExtend;
          return (
            <span>
              {workFlowFinishTime ? moment(workFlowFinishTime).format('YYYY.MM.DD HH:mm') : '-'}
            </span>
          );
        },
      },
      {
        title: '消息提醒',
        dataIndex: 'newsInfoExtend',
        key: 'newsInfoExtend',
        width: 100,
        render: data => {
          const { needPush } = data || {};
          return (
            <Badge
              color={needPush === '1' ? '#52C41A' : '#C3C3C3'}
              text={needPush === '1' ? '是' : '否'}
            />
          );
        },
      },
    ];
    if (orgType === 'education_bureau') {
      columns.push({
        title: '文章同步',
        dataIndex: 'newsInfoExtend',
        key: 'report',
        width: 120,
        render: data => {
          const { needDown } = data;
          return (
            <Badge
              color={needDown === '1' || needDown === '2' ? '#52C41A' : '#C3C3C3'}
              // eslint-disable-next-line no-nested-ternary
              text={needDown === '1' ? '是' : '否'}
            />
          );
        },
      });
    }
    columns.push({
      title: '上报教育局',
      dataIndex: 'newsInfoExtend',
      key: 'report',
      width: 120,
      render: data => {
        const { needUp } = data;
        return (
          <Badge
            color={needUp === '1' ? '#52C41A' : '#C3C3C3'}
            text={needUp === '1' ? '是' : '否'}
          />
        );
      },
    });

    if (!eduAppCode[getAppCode()]) {
      if (orgType === 'education_bureau') {
        columns.push({
          title: '发布对象',
          dataIndex: 'selectId',
          key: 'selectId',
          width: 120,
          fixed: 'right',
          render: (data, record) => {
            const { selectIdType } = record;
            const { isTiming } = record.newsInfoExtend;
            return (
              <div className='option-wrap'>
                {this.showPublisher(data, selectIdType)}
                {/* {data ? (
                  <div
                    style={{ color: '#1785EC' }}
                    onClick={e => {
                      e.stopPropagation();
                      this.showSelectOrg(data);
                    }}
                  >
                    查看
                  </div>
                ) : '-'} */}
                {
                  isTiming === 1 && (
                    <Popconfirm
                      title="你确定取消定时发布吗？"
                      onConfirm={e => {
                        e.stopPropagation();
                        this.confirmCancleTimeSend(record.id)
                      }}
                      onCancel={e => e.stopPropagation()}
                    >
                      <div
                        className='time-send'
                        onClick={e => {
                          e.stopPropagation()
                        }}
                      >
                        取消定时发布
                      </div>
                    </Popconfirm>
                  )
                }
              </div>
            );
          },
        });
      } else {
        columns.push({
          title: '操作',
          dataIndex: 'selectId',
          key: 'selectId',
          width: 120,
          fixed: 'right',
          render: (data, record) => {
            const { isTiming } = record.newsInfoExtend;
            return (
              <div className='option-wrap'>
                {
                  isTiming === 1 && (
                    <Popconfirm
                      title="你确定取消定时发布吗？"
                      onConfirm={e => {
                        e.stopPropagation();
                        this.confirmCancleTimeSend(record.id)
                      }}
                      onCancel={e => e.stopPropagation()}
                    >
                      <div
                        // className='time-send'
                        onClick={e => {
                          e.stopPropagation()
                        }}
                      >
                        取消定时发布
                      </div>
                    </Popconfirm>
                  )
                }
              </div>
            );
          },
        });
      }
    }
    this.setState({ columns });
  };

  changePage = (page, pageSize) => {
    const { params } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
    };
    this.setState({ params: tempParams });
    this.fetchEditAndCheckList(tempParams);
  };

  // 跳转详情
  handleGoToDetail = id => {
    router.push(
      `/${getPathHeader()}/submissions/editCheck/approvalDetail?id=${id}&appCode=${getAppCode()}`
    );
  };

  upItem = (record, index) => {
    const { selectedRows } = this.state;
    const tempArr = [];
    selectedRows.forEach((item, num) => {
      if (record.id !== item.id) {
        if (index === num + 1) {
          tempArr.push(record);
        }
        tempArr.push(item);
      }
    });
    this.setState({ selectedRows: tempArr });
  };

  downItem = (record, index) => {
    const { selectedRows } = this.state;
    const tempArr = [];
    selectedRows.forEach((item, num) => {
      if (record.id !== item.id) {
        if (index === num - 1) {
          tempArr.push(item);
          tempArr.push(record);
        } else {
          tempArr.push(item);
        }
      }
    });
    this.setState({ selectedRows: tempArr });
  };

  deleteItem = record => {
    const { selectedRows } = this.state;
    const tempArr = [];
    const idArr = [];
    selectedRows.forEach(item => {
      if (item.id !== record.id) {
        tempArr.push(item);
        idArr.push(item.id);
      }
    });
    this.setState({ selectedRows: tempArr, selectedRowKeys: idArr });
  };

  onSelectRow = (record, selected) => {
    const { selectedRowKeys, selectedRows } = this.state;
    if (
      selectedRows.length > 0 &&
      selectedRows[0].newsInfoExtend.needPush !== record.newsInfoExtend.needPush
    ) {
      return;
    }
    let tempSelectedRows = [...selectedRows];
    let tempSelectedRowKeys = [...selectedRowKeys];
    if (selected && selectedRows.length === 8) {
      message.warning('最多只能选8篇');
      return;
    }
    if (selected && selectedRows.length < 8) {
      tempSelectedRowKeys.push(record.id);
      tempSelectedRows.push(record);
    } else if (!selected) {
      tempSelectedRowKeys = tempSelectedRowKeys.filter(itemKey => itemKey !== record.id);
      tempSelectedRows = tempSelectedRows.filter(item => item.id !== record.id);
    }

    this.setState({
      selectedRowKeys: tempSelectedRowKeys,
      selectedRows: tempSelectedRows,
    });
  };

  setBatch = selectIdType => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length <= 0) {
      message.warning('请选择需要批量设对象的文章');
      return null;
    }
    // this.setState({ selectIdType })
    this.setSelectOrg(selectedRowKeys.join(','), selectIdType);
  };

  setTime = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length <= 0) {
      message.warning('请先选择需要定时发布的内容');
      return null;
    }

    this.setState({
      isTimeModalVisible: true
    })

  }

  preview = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length <= 0) {
      message.warning('请选择需要预览的文章');
      return;
    }
    this.fetchNewsPreview(selectedRowKeys);
  };

  publish = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length <= 0) {
      message.warning('请选择需要发布的文章');
      return;
    }
    this.fetchNewsPublish(selectedRowKeys);
  };

  removeList = () => {
    const { selectedRowKeys } = this.state;
    if (selectedRowKeys.length <= 0) {
      message.warning('请选择需要移除的文章');
      return;
    }
    this.userChooseRemove(selectedRowKeys);
  };

  renderFooter = () => {
    const { selectedRows } = this.state;

    const footerParams = {
      states: !0,
      demFooter: (
        <>
          <Button type="default" onClick={this.removeList}>
            移除
          </Button>
          {selectedRows.length > 0 && selectedRows[0].newsInfoExtend.needPush === '1' && (
            <Button type="default" onClick={this.preview}>
              预览
            </Button>
          )}
          <Button type="primary" onClick={this.publish}>
            发布
          </Button>
        </>
      ),
    };
    return footerParams;
  };

  sureTime = () => {
    const { form, dispatch } = this.props;
    const { validateFields, getFieldsValue } = form;
    const values = getFieldsValue();
    const { publishDate, fromApp } = values;
    const { selectedRowKeys, params } = this.state;

    validateFields(err => {
      if (!err) {
        this.setState({ loading: true });
        dispatch({
          type: 'editCheck/fetchTimedPublish',
          params: {
            ids: selectedRowKeys.join(','),
            appCode: getAppCode(),
            time: moment(publishDate).format('YYYY-MM-DD HH:mm'),
            fromApp
          },
        })
          .then(() => {
            this.setState({ isTimeModalVisible: false, selectedRows: [], selectedRowKeys: [], });
            form.resetFields();
            this.fetchOrgType(params);
            message.success('操作成功');
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      }
    });
  }

  saveSelectSignature = data => {
    const { selectSignature, groupInfoList = [], orgRelInfoList = [], tagInfoList = [] } = data;
    const orgArr = [...groupInfoList, ...orgRelInfoList];
    if (orgArr.length > 0 && tagInfoList.length > 0) {
      this.setState({
        selectSignature
      })
    } else {
      this.setState({
        selectSignature: ''
      })
    }
  }

  handleOk = () => {
    const { selectSignature, selectedRowKeys } = this.state;
    const that = this;
    this.setState({
      selectUserRangeModalVisible: false
    }, () => {
      that.sureSend(selectSignature, selectedRowKeys.join(','), 2)
    })
  }

  handleCancel = () => {
    this.setState({
      selectUserRangeModalVisible: false,
    })
  }

  render() {
    const { form } = this.props;
    const {
      columns,
      loading,
      dataSource,
      params,
      totalElements,
      selectedRowKeys = [],
      selectedRows = [],
      showSelectModalVisible,
      selectId,
      orgType,
      isTimeModalVisible,
      selectSignature,
      selectUserRangeModalVisible,
    } = this.state;
    const { page } = params;

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const rowSelection = {
      selectedRowKeys,
      onSelect: this.onSelectRow,
      getCheckboxProps: record => ({
        disabled:
          selectedRows.length > 0
            ? record.newsInfoExtend.needPush !== selectedRows[0].newsInfoExtend.needPush
            : false, // Column configuration not to be checked
      }),
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
      rowSelection,
    };

    const alertParams = {
      states: !0, // true为展示 false不展示
      type: 'info', // 错误类型（success info warning error）四种，默认为warning类型
      message:
        '说明: 可批量选择多篇文章发布，属性为不进行消息提醒的文章时，发布后文章不会进行消息提醒，发布前可先进行内容的预览。发布时，同时选择不进行消息提醒且不同步，仅在当前组织更新', // 展示的内容
    };

    const selectUserProps = {
      multiple: true,
      selectType: 'dept',
      strictOrgRel: true,
      showTabList: ['orgRel'],
      selectSignature: selectId,
      isSaveSelectSignature: true,
      requestParams: {
        strictUser: true,
        selectTypeList: ['org_rel'],
      },
    };

    const customerFormItemLayout = {
      labelCol: { span: 5 },
      wrapperCol: { span: 19 },
    };

    const endTimeProps = {
      form,
      label: "发布时间",
      keyName: "publishDate",
      datePickerFormat: "YYYY-MM-DD HH:mm",
      message: "请选择发布时间",
      showTime: { defaultValue: moment("00:00", "HH:mm") },
      myRules: [{ required: true, message: "请选择发布时间", }]
    };

    const fromAppProps = {
      form,
      value: 17,
      label: '推送应用',
      keyName: 'fromApp',
      isRequired: true,
      optionData: [
        { value: 17, label: '微官网' },
        { value: 18, label: '活动打卡' },
      ],
    };

    const selectUserRangeProps = {
      tagProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
      },
      orgRelProps: {
        subtitle: '已选对象',
        btnText: '选择',
        btnDetele: true,
        showTabList: ['orgRel'],
        requestParams: {
          selectTypeList: ['org_rel',]
        }
      },
      title: '推送范围',
      funCallbackSignature: data => this.saveSelectSignature(data)
    }

    return (
      <Container
        breStates={!0}
        alertParams={alertParams}
        version={2}
        footerParams={this.renderFooter()}
      >
        <ListPage {...pageProps}>
          <section className="table-area">
            <div className="left">
              <SelectList
                selectedRows={selectedRows}
                tips="单次最多可同步8篇文章，外链文章、文章中存在链接不可 同步，文章中附件内容无法同步至公众号"
                deleteItem={this.deleteItem}
                downItem={this.downItem}
                upItem={this.upItem}
              />
            </div>

            <div className="right">
              {
                Number(getAppCode()) === 1 && orgType === 'education_bureau' && (

                  <Dropdown
                    placement="bottomRight"
                    overlay={(
                      <Menu>
                        <Menu.Item onClick={() => this.setBatch(5)}> 本组织 </Menu.Item>
                        <Menu.Item onClick={() => this.setBatch(1)}> 按组织设置 </Menu.Item>
                        <Menu.Item onClick={() => this.setBatch(2)}> 按标签设置 </Menu.Item>
                      </Menu>
                    )}
                  >
                    <Button style={{ marginBottom: 16 }}>
                      批量设置对象
                    {/* <Tooltip
                      placement="top"
                      title="选择未设置对象的文章，可批量设置对象。已设置对象的资讯无法重新设置对象。"
                    > */}
                      <Icon type="question-circle" />
                      {/* </Tooltip> */}
                    </Button>
                  </Dropdown>

                )
              }
              {
                !eduAppCode[getAppCode()] && (
                  <Tooltip
                    placement="top"
                    title="未设置发布对象的内容设置定时发布后不生效。"
                  >
                    <Button onClick={this.setTime} style={{ marginBottom: 16, marginLeft: 10 }}>
                      定时发布
                  <Icon type="question-circle" />
                    </Button>
                  </Tooltip>
                )
              }
              <ListTable {...tableProps} />
            </div>
          </section>
          <Modal
            wrapClassName="select-org-modal-wrap"
            centered
            title="查看发布对象"
            visible={showSelectModalVisible}
            onOk={() => {
              this.setState({ showSelectModalVisible: false, selectId: '' });
            }}
            onCancel={() => {
              this.setState({ showSelectModalVisible: false, selectId: '' });
            }}
          >
            <SelectUserResult selectUserProps={selectUserProps} />
          </Modal>
          <Modal
            centered
            title="定时发布"
            visible={isTimeModalVisible}
            onOk={this.sureTime}
            onCancel={() => {
              this.setState({ isTimeModalVisible: false });
            }}
          >
            <FormCreate customerFormItemLayout={customerFormItemLayout}>
              <DateAndTime {...endTimeProps} />
              {
                orgType === 'education_bureau' && <FormSelect {...fromAppProps} />
              }
            </FormCreate>
          </Modal>
          <Modal
            title="选择对象"
            width={931}
            wrapClassName='nbugs-select-user-range-modal'
            visible={selectUserRangeModalVisible}
            onCancel={this.handleCancel}
            footer={[
              <Button onClick={this.handleCancel}>取消</Button>,
              <Button type="primary" onClick={this.handleOk} disabled={!selectSignature.length}>
                确定
              </Button>
            ]}
          >
            <div className='content'>
              <p> <span style={{ color: '#F5222D' }}>*</span>系统标签内组织精准推送
                <Tooltip placement="top" title='从已有系统标签规则选择组织精准推送' autoAdjustOverflow>
                  <Icon type="question-circle" />:
                </Tooltip>
              </p>
              <SelectUserRange {...selectUserRangeProps} />
            </div>
          </Modal>
        </ListPage>
      </Container>
    );
  }
}

const EditCheckFrom = Form.create()(EditCheck);
export default EditCheckFrom;
